<template>
    <b-modal
        v-model="modal"
        :id="'assignment-show-sub-assignment-partner-create-modal-' + subAssignmentIn.id"
        title="Samenwerkingsgroep"
        modal-class="apprentice-default-modal"
        size="lg"
        @show="onShow"
        @ok="onOk"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-title="$t('common.save')">
        <h5>Groepje maken voor deelopdracht "{{ subAssignmentIn.name }}"</h5>
        <ul>
            <li v-if="subAssignmentIn.assignment_cooperations[0].minimum > 1">
                Minimale groepsgrootte: {{ subAssignmentIn.assignment_cooperations[0].minimum }} (inclusief jezelf)
            </li>
            <li v-if="subAssignmentIn.assignment_cooperations[0].maximum > 1">
                Maximale groepsgrootte: {{ subAssignmentIn.assignment_cooperations[0].maximum }} (inclusief jezelf)
            </li>
        </ul>

        <b-form-group
            class="assignmnent-partner-checkbox"
            v-if="subAssignmentIn.assignment_cooperations[0].minimum <= 1"
            :label="$t('assignment.partner.collaborate')"
            label-for="assignment-partner-cooperation">
            <b-form-checkbox
                id="assignment-partner-cooperation"
                v-model="cooperation"
                :value="true"
                :unchecked-value="false">
            </b-form-checkbox>
        </b-form-group>

        <b-form-group
            class="assignmnent-partner-select"
            v-if="cooperation"
            :label="$t('common.students')"
            label-for="assignment-partner-select">
            <design-2021-apprentice-multiselect-component
                id="assignment-partner-select"
                v-model="selectedStudents"
                :placeholder="$t('assignment.partner.select_students')"
                label="full_name"
                :max="limit"
                :options="students"
                :show-labels="false">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-assignment-show-sub-assignment-partner-create-modal-component',
    props: {
        subAssignmentIn: Object,
        groupIdIn: Number,
        projectIdIn: Number,
    },
    data() {
        return {
            cooperation: true,
            selectedStudents: [],
            students: [],
            loaded: false,
            modal: false,
        };
    },
    computed: {
        limit() {
            return this.subAssignmentIn.assignment_cooperations[0].maximum
                ? this.subAssignmentIn.assignment_cooperations[0].maximum - 1
                : null;
        },
        withinMarges() {
            let totalStudents = this.selectedStudents.length + 1;
            const { maximum, minimum } = this.subAssignmentIn.assignment_cooperations[0];
            const underMax = !maximum || totalStudents <= maximum;
            const overMin = !minimum || totalStudents >= minimum;

            return underMax && overMin;
        },
    },
    methods: {
        onOk(bvModalEvt) {
            bvModalEvt.preventDefault();

            if (this.cooperation && !this.selectedStudents.length) {
                this.alert.notice(
                    this.$t('assignment.partner.incomplete_form'),
                    this.$t('assignment.partner.no_students_chosen_yet'),
                );
                return;
            }

            if (!this.withinMarges) {
                this.alert.notice(
                    this.$t('assignment.partner.outside_the_margins'),
                    this.$t('assignment.collaborate_choose_right_amount_partners'),
                );
                return;
            }

            const data = {
                sub_assignment_id: this.subAssignmentIn.id,
                group_id: this.groupIdIn,
                selected_student_ids: this.cooperation ? this.selectedStudents.map((student) => student.id) : [],
            };

            this.alert.saving();
            this.axios.post(this.routes.subAssignmentAssignmentPartnerStore(), data).then(
                (response) => {
                    this.subAssignmentIn.assignment_cooperations[0].addRelation('assignment_partners', response.data);
                    this.modal = false;
                    this.alert.success();
                },
                (error) => {
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.type &&
                        error.response.data.type === 'students_taken'
                    ) {
                        if (error.response.data.taken_students.find((student) => student.id === this.$authUser.id)) {
                            this.alert.notice(
                                this.$t('assignment.already_in_a_group_alert_title'),
                                this.$t('assignment.already_in_a_group_alert_body_sub_assignment'),
                            );
                        }

                        this.alert.notice(
                            this.$t('assignment.partner.students_already_chosen'),
                            this.$t('assignment.partner.the_following_students_can_no_longer_be_chosen') +
                                ': ' +
                                error.response.data.taken_students.map((student) => student.full_name).join(', '),
                        );
                    } else {
                        this.alert.ajaxError(error);
                    }
                },
            );
        },

        onShow() {
            if (!this.loaded) {
                this.axios
                    .get(
                        this.routes.subAssignmentAssignmentPartnerAvailableStudents(
                            this.projectIdIn,
                            this.subAssignmentIn.id,
                        ),
                    )
                    .then(
                        (response) => {
                            this.students = response.data;
                            this.loaded = true;
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
            }
        },
    },
};
</script>

<style scoped></style>
